// ── Beneficios para Radios en RFW — Bloque 28 ──
// 12 beneficios reales del ecosistema. No solo streaming.

export interface RadioBenefit {
  id: string;
  icon: string;
  title: string;
  description: string;
}

export const radioBenefits: RadioBenefit[] = [
  {
    id: 'audiencia',
    icon: 'ri-headphone-line',
    title: 'Mayor Audiencia',
    description: 'Llegá a oyentes de todo el mundo. Tu radio visible en el directorio RFW con buscador por país, categoría y frecuencia.',
  },
  {
    id: 'comunidad',
    icon: 'ri-group-line',
    title: 'Comunidad',
    description: 'Construí una comunidad activa alrededor de tu radio. Chat en vivo, publicaciones, interacción directa con tus oyentes.',
  },
  {
    id: 'seguidores',
    icon: 'ri-user-heart-line',
    title: 'Seguidores',
    description: 'Tus oyentes te siguen, reciben notificaciones de tus transmisiones y no se pierden nada de tu programación.',
  },
  {
    id: 'ranking',
    icon: 'ri-trophy-line',
    title: 'Ranking',
    description: 'Competí en rankings globales, por país y por categoría. Destacate entre las mejores radios de RFW.',
  },
  {
    id: 'top-fans',
    icon: 'ri-star-line',
    title: 'Top Fans',
    description: 'Identificá a tus oyentes más fieles. Rankings de participación, rachas y reconocimiento a tu comunidad más activa.',
  },
  {
    id: 'clubes',
    icon: 'ri-shield-star-line',
    title: 'Clubes',
    description: 'Creá tu club de fans exclusivo. Contenido premium, beneficios especiales y un espacio VIP para tus seguidores.',
  },
  {
    id: 'eventos',
    icon: 'ri-calendar-event-line',
    title: 'Eventos',
    description: 'Organizá y promocioná eventos en vivo. Transmisiones especiales, entrevistas, lanzamientos y coberturas.',
  },
  {
    id: 'gamificacion',
    icon: 'ri-gamepad-line',
    title: 'Gamificación',
    description: 'Mantené enganchada a tu audiencia con logros, niveles, insignias, rachas y recompensas por participar.',
  },
  {
    id: 'rfw-tv',
    icon: 'ri-tv-line',
    title: 'RFW TV',
    description: 'Tu radio puede aparecer en el canal oficial de RFW. Entrevistas, clips destacados y cobertura de eventos.',
  },
  {
    id: 'app',
    icon: 'ri-smartphone-line',
    title: 'App',
    description: 'Tus oyentes te escuchan desde la app móvil de RFW. Disponible para iOS y Android con notificaciones push.',
  },
  {
    id: 'panel',
    icon: 'ri-dashboard-line',
    title: 'Panel Profesional',
    description: 'Administrá tu radio desde un panel completo. Programación, cabina, estadísticas, comunidad y más.',
  },
  {
    id: 'hosting',
    icon: 'ri-cloud-line',
    title: 'Hosting Opcional',
    description: 'Si no tenés streaming propio, RFW te ofrece hosting de alta calidad. Vos elegís. Sin obligación.',
  },
];